import React from "react";
import PageLoader from "../../components/PageLoader/PageLoader";
import HeaderOne from "../../components/Header/HeaderOne";

const LitePaperPage = () => {
  return (
    <div>
      <PageLoader />
      <HeaderOne />

      <div className="row justify-content-center">
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              Introduction
            </h2>
          </div>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            This litepaper introduces a decentralized exchange (DEX) that aims
            to revolutionize the way individuals trade digital assets. By
            leveraging the power of blockchain technology, the DEX provides a
            secure, transparent, and efficient platform for users to trade
            cryptocurrencies and tokens directly with one another, eliminating
            the need for intermediaries and centralized control. This litepaper
            outlines the key features, benefits, and technical aspects of the
            decentralized exchange, demonstrating its potential to reshape the
            landscape of digital asset trading.
          </p>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              HEXIDO idea
            </h2>
          </div>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            The name HEXIDO is derived from the combination of Hybrid Exchange
            Platform and Initial DEX Offering. The term "Hybrid Exchange" refers
            to the integration of both centralized exchange (CEX) and
            decentralized exchange (DEX) functionalities within a single
            platform. In essence, this means that HEXIDO will provide support
            for FIAT deposits and withdrawals while incorporating decentralized
            features. HEXIDO will implement a Decentralized KYC (Know Your
            Customer) feature, which ensures that user information is not
            disclosed to the required provider. Instead, the purpose is to
            determine whether the user meets the eligibility criteria set by
            regulated domains, such as country restrictions and individual bans.
          </p>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              Setting Up HEXIDO
            </h2>
          </div>
          <h4>Create a Wallet</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-Native Wallet
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-3rd Party Wallets Get Tokens{" "}
            <br />
          </p>
          <h4>Get Tokens</h4>
          <h4>Connect Your Wallet to HEXIDO</h4>
          <h4>Liquidity</h4>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              Using HEXIDO
            </h2>
          </div>
          <h4>How to Trade on Web Application</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            To trade on a decentralized exchange (DEX), you need to connect your
            wallet, select a trading pair, set trade parameters, approve
            transactions, confirm the trade, wait for blockchain confirmation,
            and then monitor and manage your trades.
          </p>
          <h4>How to Trade on Mobile Application</h4>
          <p></p>
          <h4>Basic Swap and Advance Chart Swap</h4>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              Lottery
            </h2>
          </div>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            HEXIDO Lottery, is a feature offered by HEXIDO Binance Smart Chain
            (BSC). It is designed to provide users with a chance to win prizes
            by participating in a lottery-style game using their cryptocurrency
            holdings.
          </p>
          <h4>1. Purchase Lottery Tickets</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            To trade on a decentralized exchange (DEX), you need to connect your
            wallet, select a trading pair, set trade parameters, approve
            transactions, confirm the trade, wait for blockchain confirmation,
            and then monitor and manage your trades.
          </p>
          <h4>2. Select Lottery Numbers</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            After purchasing tickets, participants can choose their preferred
            numbers for the lottery draw. The number selection process may vary,
            but it typically involves picking a set of numbers within a specific
            range.
          </p>
          <h4>3. Wait for Lottery Draw</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Once the ticket purchase period is over, a lottery draw is conducted
            at a predetermined time. The winning numbers are randomly generated
            using a provably fair mechanism to ensure fairness and transparency.
          </p>
          <h4>4. Prize Distribution</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            If the numbers selected by a participant match the winning numbers,
            they win a share of the prize pool. The prize pool is usually
            composed of a portion of the HEX tokens collected from ticket sales.
            The more matching numbers a participant has, the larger their share
            of the prize pool.
          </p>
          <h4>5. Rollovers and Additional Draws</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            In some cases, if no participants match all the winning numbers, the
            prize pool may roll over to the next lottery draw, resulting in a
            larger jackpot. This can continue until someone wins the jackpot or
            reaches a predetermined limit.
          </p>
          <br />
          <p style={{ color: "rgb(255, 255, 255)" }}>
            It's important to note that participation in the HEXIDO Lottery
            involves a certain level of risk, and the odds of winning depend on
            the number of tickets sold and the number of participants. It's
            advisable to carefully review the rules and terms of the specific
            lottery and exercise caution when investing in any form of lottery
            or game.
          </p>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              Launchpad Participation
            </h2>
          </div>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            An IDO (Initial DEX Offering) launchpad is a platform or service
            that facilitates the launching of new cryptocurrency projects
            directly on a decentralized exchange (DEX). It serves as a launchpad
            for projects to raise funds and distribute their tokens to the
            public in a decentralized and community-driven manner. Here's how a
            decentralized IDO launchpad typically works:
          </p>
          <h4>1. Project Evaluation and Selection</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            The launchpad team evaluates and selects promising projects to be
            featured on the platform. This evaluation process may include
            assessing the project's concept, team, technology, and overall
            potential.
          </p>
          <h4>2. Token Sale Preparation</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            The selected project collaborates with the launchpad to prepare for
            the token sale. This includes determining the token distribution
            mechanism, setting the token sale parameters (such as token price
            and allocation limits), and conducting any required audits or due
            diligence.
          </p>
          <h4>3. Whitelisting and KYC</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Users interested in participating in the token sale often need to go
            through a whitelisting process. This involves providing necessary
            information and undergoing Know Your Customer (KYC) procedures to
            comply with regulatory requirements.
          </p>
          <h4>4. Token Sale Launch</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Once the token sale is ready, the launchpad platform enables users
            to purchase the project's tokens directly on HEXIDO. This allows
            participants to trade their desired cryptocurrencies for the new
            project's tokens at the specified token price.
          </p>
          <h4>5. Liquidity Pool Creation</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Simultaneously with the token sale, the launchpad facilitates the
            creation of a liquidity pool for the newly launched tokens. This
            helps establish initial liquidity and enables trading of the tokens
            on the HEXIDO immediately after the sale.
          </p>
          <h4>6. Community Participation</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            The decentralized nature of the IDO launchpad allows the community
            to participate actively in the token sale and the subsequent trading
            of the tokens. This community involvement promotes transparency,
            fairness, and decentralization in the token launch process.
          </p>
          <br />
          <p style={{ color: "rgb(255, 255, 255)" }}>
            By leveraging a decentralized IDO launchpad, projects can benefit
            from the liquidity and exposure provided by the associated DEX while
            offering community members an opportunity to participate in
            early-stage investment. It's essential for users to conduct their
            own research and exercise caution when participating in IDOs, as
            they can carry certain risks and the market can be highly volatile.
          </p>
          <table
            class="table table-bordered"
            style={{ color: "rgb(255, 255, 255)" }}
          >
            <thead>
              <tr>
                <th>Stages</th>
                <th>Ticket</th>
                <th>Allocation</th>
                <th>Criteria</th>
                <th>Staking #</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mercury</td>
                <td>1</td>
                <td>2%</td>
                <td>Like, Comment, Retweet</td>
                <td>1000</td>
              </tr>
              <tr>
                <td>Mars</td>
                <td>3</td>
                <td>3%</td>
                <td>Like, Comment, Retweet</td>
                <td>2500</td>
              </tr>
              <tr>
                <td>Venus</td>
                <td>5</td>
                <td>5%</td>
                <td>Like, Comment, Retweet</td>
                <td>5000</td>
              </tr>
              <tr>
                <td>Earth</td>
                <td>7</td>
                <td>8%</td>
                <td>Like, Comment, Retweet</td>
                <td>7500</td>
              </tr>
              <tr>
                <td>Neptune</td>
                <td>Guarantee</td>
                <td>11%</td>
                <td>Like, Comment, Retweet</td>
                <td>35000</td>
              </tr>
              <tr>
                <td>Uranus</td>
                <td>Guarantee</td>
                <td>16%</td>
                <td>Like, Comment, Retweet</td>
                <td>50000</td>
              </tr>
              <tr>
                <td>Saturn</td>
                <td>Guarantee</td>
                <td>22%</td>
                <td>None</td>
                <td>75000</td>
              </tr>
              <tr>
                <td>Jupiter</td>
                <td>Guarantee</td>
                <td>33%</td>
                <td>None</td>
                <td>100000</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              Official Listing
            </h2>
          </div>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            When projects reach out to HEXIDO for an official launch on their
            platform, they receive assistance through various marketing
            initiatives, and HEXIDO makes official announcements to the
            community regarding the trading pairs and project details. Projects
            that are verified by the HEXIDO team are granted an "official" tag
            on the platform, ensuring that users can confidently trade assets
            with confidentiality on the exchange.
          </p>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              Unofficial Listing via Liquidity Pools
            </h2>
          </div>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Any project, as long as it operates on supported blockchain
            networks, has the opportunity to initiate trading on HEXIDO's
            exchange. The process involves creating a liquidity pool and
            generating LP tokens to facilitate the trading of assets. It's
            important to note that HEXIDO does not offer any guarantees or
            support for unofficial launches. However, given the decentralized
            nature of the platform, it is feasible to create such trading pairs
            and engage in trading on HEXIDO.
          </p>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              HEXIDO Wallet
            </h2>
          </div>
          <h4>Introduction to HEXIDO Wallet</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Decentralization poses specific challenges for individuals,
            especially regarding the storage and security of wallet key phrases.
            It is solely the responsibility of individuals to safeguard their
            key phrases, as losing them can result in permanent loss of access
            to their wallets through conventional means. However, HEXIDO Wallet
            addresses this issue by introducing decentralized KYC, where the
            secret phrase directly links to both the wallet and the individual's
            identity. In the event of losing the key phrase or password,
            individuals will have the option to verify their identity once again
            and regain access to their assets.
          </p>
          <h4>Decentralized KYC</h4>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Decentralized KYC (Know Your Customer) is a concept that aims to
            provide identity verification processes while preserving privacy and
            decentralization principles. Traditional KYC processes typically
            involve sharing personal information with a centralized authority,
            such as a financial institution, to comply with regulatory
            requirements and access certain services. In contrast, decentralized
            KYC seeks to enable identity verification without the need to
            disclose personal information to a centralized entity. It utilizes
            blockchain technology and cryptographic protocols to achieve this.
            Here's how decentralized KYC works:
          </p>
          <h6>1. User-Controlled Identity</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            With decentralized KYC, individuals retain control over their
            personal data. Instead of sharing sensitive information directly
            with service providers, users can store their identity details
            securely on a decentralized network or their personal devices.
          </p>
          <h6>2. Self-Sovereign Identity</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Decentralized KYC leverages the concept of self-sovereign identity,
            where individuals have full ownership and control over their
            identity information. They can selectively share specific details
            when necessary, without relying on third-party intermediaries.
          </p>
          <h6>3. Immutable Identity Records</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Identity information can be stored on a blockchain or distributed
            ledger, ensuring its immutability and tamper-proof nature. This
            enhances the security and integrity of the identity records.
          </p>
          <h6>4. Zero-Knowledge Proofs</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Decentralized KYC often employs zero-knowledge proofs, cryptographic
            techniques that enable verification of certain information without
            revealing the actual data. This allows individuals to prove the
            authenticity of their identity attributes without disclosing
            sensitive details.
          </p>
          <h6>5. Decentralized Identity Verification</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            When an individual needs to undergo identity verification for a
            particular service or transaction, decentralized KYC protocols
            enable them to selectively disclose relevant information while
            maintaining their privacy. The verification process can involve
            cryptographic protocols, smart contracts, or other mechanisms that
            establish trust between the parties involved.
          </p>
          <h6>6. User Consent and Control</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Users have the ability to grant or revoke consent for the use of
            their identity information. They can choose which service providers
            or entities can access their data, giving them greater control over
            their privacy.
          </p>
          <br />
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Decentralized KYC aims to strike a balance between regulatory
            compliance and individual privacy, empowering users to maintain
            ownership of their identity while participating in various services
            that require identity verification. It offers a more secure and
            privacy-conscious alternative to traditional centralized KYC
            processes.
          </p>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              Mobile Wallet
            </h2>
          </div>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            A decentralized mobile wallet is a digital wallet application for
            smartphones or mobile devices that allows users to store, manage,
            and transact with their cryptocurrencies in a decentralized manner.
            It provides users with control over their funds and enhances
            security by leveraging blockchain technology and decentralized
            protocols.
            <br />
            Here are the key aspects and features of a decentralized mobile
            wallet:
          </p>
          <h6>1. User Control</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            A decentralized mobile wallet gives users full control over their
            funds. They typically have sole access to their private keys or seed
            phrases, which are used to securely manage and authenticate
            transactions.
          </p>
          <h6>2. Decentralized Storage</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Instead of relying on a central authority or server, decentralized
            mobile wallets store cryptocurrency data directly on the user's
            device or through a distributed network. This ensures that the user
            has direct ownership and control over their funds.
          </p>
          <h6>3. Blockchain Integration</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Decentralized mobile wallets interact directly with various
            blockchain networks, allowing users to manage multiple
            cryptocurrencies and tokens within a single interface. They can
            send, receive, and store different types of digital assets supported
            by the integrated blockchains.
          </p>
          <h6>4. Security Features</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Decentralized mobile wallets prioritize security by implementing
            robust encryption methods and incorporating features like biometric
            authentication (fingerprint or face recognition) and PIN codes to
            protect access to the wallet.
          </p>
          <h6>5. Transaction Functionality</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Users can initiate transactions directly from their mobile wallets,
            sending and receiving cryptocurrencies to and from other wallet
            addresses. They can also view transaction history, monitor account
            balances, and generate QR codes for easy payment processing.
          </p>
          <h6>6. DApp Integration</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Many decentralized mobile wallets provide support for decentralized
            applications (DApps). Users can interact with various DApps directly
            from their wallets, accessing features like decentralized exchanges,
            lending platforms, or other blockchain-based services.
          </p>
          <h6>7. Cross-Platform Accessibility</h6>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Decentralized mobile wallets are vailable on multiple platforms,
            including iOS and Android, enabling users to access their funds and
            manage their cryptocurrencies from different devices.
          </p>
          <br />
          <p style={{ color: "rgb(255, 255, 255)" }}>
            By using a decentralized mobile wallet, individuals can enjoy the
            benefits of enhanced security, control, and privacy when managing
            their cryptocurrencies on the go. It allows them to have direct
            ownership and responsibility for their funds while leveraging the
            power of blockchain technology in a mobile-friendly and
            user-friendly manner.
          </p>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              HEXIDO Tokenomics
            </h2>
          </div>
          <table
            class="table table-bordered"
            style={{ color: "rgb(255, 255, 255)" }}
          >
            <thead>
              <tr>
                <th>Total Supply</th>
                <th>100000000</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Pre-Seed</td>
                <td>5%</td>
                <td>5000000</td>
              </tr>
              <tr>
                <td>Seed</td>
                <td>7%</td>
                <td>7000000</td>
              </tr>
              <tr>
                <td>IDO 1</td>
                <td>5%</td>
                <td>5000000</td>
              </tr>
              <tr>
                <td>IDO 2</td>
                <td>5%</td>
                <td>5000000</td>
              </tr>
              <tr>
                <td>Liquidity</td>
                <td>16%</td>
                <td>16000000</td>
              </tr>
              <tr>
                <td>Ecosystem&Development</td>
                <td>10%</td>
                <td>10000000</td>
              </tr>
              <tr>
                <td>Partnership&Marketing</td>
                <td>10%</td>
                <td>10000000</td>
              </tr>
              <tr>
                <td>Team</td>
                <td>15%</td>
                <td>15000000</td>
              </tr>
              <tr>
                <td>Advisors</td>
                <td>4%</td>
                <td>4000000</td>
              </tr>
              <tr>
                <td>Staking Rewards</td>
                <td>22%</td>
                <td>22000000</td>
              </tr>
              <tr>
                <td>Airdrop</td>
                <td>1%</td>
                <td>1000000</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-xl-8">
          <div className="section-title text-center mb-50">
            <h2
              className="title"
              style={{ color: "rgb(39, 220, 139)", paddingTop: "50px" }}
            >
              Governance
            </h2>
          </div>
          <p style={{ color: "rgb(255, 255, 255)" }}>
            Voting empowers the HEXIDO community, granting them the opportunity
            to actively influence the future development of HEXIDO. It allows
            community members to express their opinions and shape the direction
            in which HEXIDO evolves.
          </p>
          <br />
          <p style={{ color: "rgb(255, 255, 255)" }}>
            The HEXIDO community actively shares proposals, serving as a
            platform for community members to express their ideas and
            perspectives. These proposals showcase the community's viewpoints
            and suggestions. The HEXIDO team thoroughly evaluates each community
            vote, regularly selecting outstanding ideas and designs that receive
            substantial community support. These selected proposals have the
            potential to be incorporated into future product releases or core
            voting proposals.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LitePaperPage;
